<template>
  <div class="box">
    <!-- <img :src="img" alt="" srcset="" /> -->
    <div class="boxlist" v-for="(item, index) in itemarr" :key="index">
      <div class="icon1"></div>
      <!-- {{item | jsonparse}} -->
      <!-- {{item.data[0].formObjects[0].value | jsonparse}}
      {{item.data[0].formObjects[1].value | jsonparse}}
      {{item.data[0].formObjects[2].value | jsonparse}} -->
      <card2
        class="msg"
        :info="{
          key: item.panelName || item.data[0].formObjects[0].name,
          val: filterGetStatusByValue(filterJsonStrParse(item.data[0].formObjects[0].value,'value'),item.data[0].formObjects[0].statusMap),
          color: filterGetStatusByValue(filterJsonStrParse(item.data[0].formObjects[0].value,'value'),item.data[0].formObjects[0].statusMap)==='正常'?'green':'red',
          unit: '',
          icon: 'icon-suo',
        }"
      ></card2>
      <piecharts class="chart" :info="{
        pie: filterJsonStrParse(item.data[0].formObjects[1].value,'value'),
        key:  item.data[0].formObjects[1].name,
        val: filterJsonStrParse(item.data[0].formObjects[1].value,'value'),
        unit:item.data[0].formObjects[1].unit,
      }"></piecharts>
      <piecharts class="chart" :info="{
        pie: filterJsonStrParse(item.data[0].formObjects[2].value,'value'),
        key: item.data[0].formObjects[2].name,
        val: filterJsonStrParse(item.data[0].formObjects[2].value,'value'),
        unit: item.data[0].formObjects[2].unit,
      }"></piecharts>
    </div>
  </div>
</template>

<script>
import img from "../img/3.png";

import card2 from "../valstatus/card2.vue";
import piecharts from "../charts/pie.vue";
// import cfg from "./config.js";
export default {
  components: { piecharts, card2 },
  props: ["datainfo"],
  mounted() {
    this.itemarr = this.datainfo.data;
  },
  data() {
    return {
      img,
      itemarr: [],
      info1: {
        pie: 25,
        key: '温度',
        val: 25,
        unit: '℃',
      },
      info2: {
        pie: 25,
        key: '湿度',
        val: 25,
        unit: '%',
      },
      val5: {
        key: '告警状态',
        val: '正常',
        color: 'green',
        unit: '',
        icon: 'icon-suo',
      },
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
img {
  position: absolute;
  width: 100%;
  left: 0;
  top: -0.04rem;
  z-index: 0;
}
.box {
  overflow: hidden;
}
.boxlist {
  height: 0.4rem;
  overflow: hidden;
}
.icon1 {
  font-size: 0.14rem;
  color: #0f69ca;
  width:0.2rem;
  height: 0.14rem;
  margin-top: 0.12rem;
  margin-left: 0.01rem;
  float: left;
  background-size: 70% auto;
  background-position: left center;
  background-repeat: no-repeat;
  background-image: url(../img/kt.png);
  border-right: 1px solid rgba($color: #0f69ca, $alpha: 0.5);
}
.msg {
  width: 0.5rem!important;
  margin-top: 0.12rem;
  margin-left: 0.05rem;
  float: left;
  overflow: hidden;
  zoom: 0.8;
}
.chart {
  margin-top: 0.06rem;
  margin-left: 0.1rem;
  overflow: hidden;
  float: left;
}
</style>


// WEBPACK FOOTER //
// src/components/webgl/ui/data/kongtiao.vue